export default {
  contact_information: "Datos de contacto",
  decimal_separator: ",",
  form: {
    email: "E-mail",
    password: "Contraseña",
    password_short: "Clave",
    tag_id: "ID de chip",
    tag_id_short: "ID",
    tag_id_long: "ID de chip (Primeros 14 dígitos)",
    name: "Nombre",
    surname: "Apellidos",
    document: "Documento de identidad",
    phone_number: "Teléfono",
    birthdate: "Fecha de nacimiento",
    gender: "Género",
    country: "País",
    locator: "Código de entrada",
    locator_short: "Código",
  },
  balance: {
    profile: "Perfil",
    log_out: "Cerrar sesión",
  },
  gender: {
    MALE: "Masculino",
    FEMALE: "Femenino",
  },
  actions: {
    sign_up: "Regístrate",
    sign_in: "Inicia sesión",
    recover_password: "Recuperar mi contraseña",
    already_have_account: "Ya tengo una cuenta",
    back_to_login: "Volver al inicio",
    not_remember_password: "No recuerdo mi contraseña",
    register_prompt: "¿Es tu primera vez aquí?",
    accept: "¡Vale!",
    close: "Cerrar",
    change_password: "Cambiar mi contraseña",
    set_password: "Añadir mi contraseña",
    request_refund: "Solicitar devolución de saldo",
    recharge: "Recargar",
    confirm_request: "Confirmar solicitud",
    sign_with_tag: "Regístrate con tu chip",
    sign_with_ticket: "Regístrate con tu entrada",
    change_sign_up_method: "Cambiar forma de registro",
    sign_up_type: {
      no_reference: "Email",
      tag: "Chip NFC",
      ticket: "Ticket",
    },
    confirm_select: "Continuar",
    cancel: "Cancelar",
    ok: "Ok",
    see_more: "Ver más",
  },
  headers: {
    sign_up_title: "Registro",
    sign_up_type: "Elige como quieres acceder",
    sign_up: "Completa tus datos",
    sign_up_success: "¡Ya casi está!",
    sign_up_already: "¿Ya tienes una cuenta?",
    do_not_have_code: "No tengo un código de entrada",
    do_not_have_tag: "No tengo un código de Chip NFC",
    do_not_have_code_or_tag: "No tengo un código de entrada ni Chip NFC",
    sign_in: "Entrar",
    hello: "Hola!,"
  },
  sign_up_options: {
    locator: "Código Entrada",
    tag: "Código Chip NFC",
    email: "Email",
  },
  change_password: {
    title: "Nueva contraseña",
    subtitle:
      "Escribe una nueva contraseña y podras acceder de nuevo a tu cuenta.",
    password: "Nueva Contraseña",
    repeat_password: "Repetir Contraseña",
    no_match: "La contraseña debe coincidir en ambos campos",
    email_send: "Contraseña cambiada!",
    email_send_subtitle: "Ya puedes continuar disfrutando de tu chip cashless",
    short_password: "La contraseña debe ser de al menos 8 caracteres",
  },
  recover: {
    title: "Recuperar contraseña",
    subtitle:
      "Introduce tu email y te enviaremos las instrucciones para recuperar tu contraseña.",
    email: "Email",
    go_back: "Volver",
    email_send: "¡Correo enviado!",
    email_send_subtitle:
      "Si el e-mail introducido coincide con el que usaste para registrarte, recibirás las instrucciones para elegir una nueva contraseña.",
  },
  sign_in: {
    email: "Email",
    password: "Contraseña",
    login: "Iniciar sesión",
    login_with_google: "Iniciar sesión con Google",
    login_with_apple: "Iniciar sesión con Apple",
    go_back: "Volver",
    forgot_password: "¿Olvidaste contraseña?",
    have_account: "¿No tienes cuenta?",
    register: "Registrate aquí",
    email_or_password_cannot_be_null: "Email o contraseña no pueden estar vacios",
  },
  sign_up: {
    search: "Buscar",
    continue_with_google: "Continuar con Google",
    continue_with_apple: "Continuar con Apple",
    read_terms: "He leído y acepto los",
    terms: "términos y condiciones",
    go_back: "Volver",
    access: "Acceder",
    confirm_password: "Confirmar contraseña",
    email_send: "Email enviado!",
    email_send_subtitle:
      "Hemos enviado un correo para crear tu cuenta, revisa tu correo o tu carpeta de spam",
    locator: {
      name: "Código Entrada",
      title: "1.- Código Entrada",
      title_second_step: "2.- Identificación",
      subtitle: "Introduce el código de tu entrada y realiza la búsqueda.",
      success: "¡Código de entrada confirmado!",
      failed: "¡Vaya! No hemos encontrado este código de entrada."
    },
    tag: {
      name: "Código Chip NFC",
      title: "1.- Código Chip NFC",
      title_second_step: "2.- Identificación",
      subtitle: "Introduce el código de tu Chip NFC y realiza la búsqueda.",
      success: "¡Código de Chip NFC confirmado!",
      failed: "¡Vaya! No hemos encontrado este código de Chip NFC."
    },
    no_reference: {
      title: "1.- Acceso con Email",
      subtitle: "Introduce tu email",
    },
    set_password: {
      title: "Crear contraseña",
      subtitle: "Elige una contraseña y tendras tu cuenta para disfrutar!",
      password: "Contraseña",
      repeat_password: "Repetir Contraseña",
      no_match: "La contraseña debe coincidir en ambos campos",
      email_send: "Cuenta creada!",
      email_send_subtitle: "Hemos enviado un correo con la información de uso, revisa tu correo o tu carpeta de spam",
      short_password: "La contraseña debe ser de al menos 8 caracteres",
    },
    placeholder_example: "Ej: 000021504545",
  },
  main: {
    invitations: "Tus invitaciones",
    reached_end: "No hay más transacciones",
    no_transactions: "Parece que todavía no tienes transacciones.",
    load_more_transactions: "Cargar más",
    recharge_prompt: "¿Quieres recargar tu chip?",
    transactions_warning:
      "Las transacciones pueden no estar actualizadas debido a problemas de conexión.",
    balance: "Mi saldo",
    token: "Invitaciones",
    recharge: "Recargar",
    pay: "Pagar",
    redeem_bracelet: "Canjear Chip NFC",
    pre_order: "Pre-order",
    transactions: "Transacciones",
    balance_return: "Devolución de saldo",
    balance_return_disabled_msg: "Se activará el {date}",
    user_data: "Datos usuario",
    more_options: "Ver más opciones",
    back_home: "Volver al menú principal",
    see_qr: "Ver QR",
    products: "Productos",
    my_token: "Mis Invitaciones",
    no_tokens: "No tienes tokens",
    no_discount_coupons: "No tienes cupones de descuento",
    available_discount_coupons: "¡Tienes {total_discounts} beneficios disponibles para canjear!",
    benefits: "Beneficios",
    show_expired_coupons: "Mostrar cupones expirados",
    check_your_benefits: "¡Consulta tus beneficios!"
  },
  transactions: {
    title: "Transacciones",
    last_transactions: "Últimas transacciones",
    all_transactions: "Mostrando todas las transacciones",
    sync_warning:
      "Las transacciones pueden no estar actualizadas debido a problemas de conexión",
    transaction_types: {
      title: "Tipo transacción",
      ORDER: "Pago de pedido",
      ORDER_REFUND: "Reembolso de pedido",
      RECHARGE: "Recarga de saldo",
      RECHARGE_REFUND: "Reembolso de recarga",
      TOKEN_DECREMENTAL: "Pago con invitación",
      TOKEN_INCREMENTAL: "Invitación",
      TOKEN: "Recarga de tokens",
      ONLINE: "Online",
    },
    origin: {
      ORDER: "Pago en ",
      ORDER_REFUND: "Reembolsado en ",
      RECHARGE: "Recarga en ",
      RECHARGE_REFUND: "Reembolsado en ",
      TOKEN_DECREMENTAL: "Pago con invitación en ",
      TOKEN_INCREMENTAL: "Invitación en ",
    },
    with_reference: {
      mercadopgo: " con Mercado Pago",
      paylands: " con tarjeta",
      mit: " con tarjeta",
    },
    station: "Estación",
    has_refund: {
      total: "Esta transacción ha sido totalmente reembolsada.",
      partial: "Importe reembolsado: {whole}{separator}{decimal}{currency}",
    },
    total: "Total",
    total_tokens: "Total tokens",
    got_invitation: "¡Has recibido una invitación!",
    product: "Producto",
    quantity_short: "Cant.",
    price: "Precio",
    no_transactions: "No tienes transacciones",
  },
  mercadopago: {
    qr_placement: "Puedes encontrar tu QR en tu tarjeta del evento.",
    app_recharge: "o recarga desde esta app",
    recharge_instructions: `Escanea el código QR con la aplicación de Mercado Pago y completa el proceso de pago. La recarga aparecerá en tu saldo poco después de completarse.\nPuedes descargar la app desde tu respectiva tienda de aplicaciones.`,
  },
  payment: {
    recharge_your_wristband: "Recarga tu chip",
    payment_method: "Método de pago",
    upgrade_to: "Ascender a {category}",
    methods: {
      PAYLANDS: "Tarjeta (paylands)",
      MERCADOPAGO: "Mercado Pago",
      MIT: "Tarjeta (centro de pagos)",
      PVS: "Tarjeta (PVS)"
    },
    topup_with: {
      paylands: "Recarga con tarjeta (paylands)",
      mercadopago: "Recarga con Mercado Pago",
      mit: "Recarga cont Tarjeta (centro de pagos)",
      pvs: "Recarga con Tarjeta (PVS)"
    },
    new_card: "Pagar con nueva tarjeta",
    your_cards: "Tus tarjetas",
    pay_with_card: "Pagar con esta tarjeta",
    card: {
      holder: "Titular",
      expiry: "Caduca",
    },
    success: {
      category_updated: "¡Has actualizado tu categoría!",
      current_balance: "El pago se ha completado correctamente",
      button: "Inicio",
      tip: "Puede que el saldo tarde un tiempo en estar disponible en tu chip. Por favor, ten paciencia.",
      tip_category:
        "Puede que la categoría tarde un tiempo en actualizarse en tu chip. Por favor, ten paciencia.",
      title: "¡Completado!",
    },
    error: {
      tip: "Algo ha ido mal durante el proceso de pago. Por favor, reinténtalo para completar tu recarga.",
      button: "Reintentar",
      title: "¡Vaya!",
    },
    warning: [
      "Ten en cuenta que el saldo mostrado puede no coincidir con el de tu wallet correctamente (esto debido a problemas de conexión).",
      "El saldo indicado por tu Chip NFC siempre será el más preciso y correcto.",
    ],
  },
  categories: {
    upgrade: "Ascender",
    no_category: "No tienes una categoría",
    title: "Ascender de categoría",
  },
  tips: {
    recover_password:
      "Te enviaremos las instrucciones para recuperar tu contraseña al e-mail que usaste para registrarte.",
    tag_id: {
      tag_placement:
        "Puedes encontrar el ID de tu chip en la parte delantera o trasera.",
      id_description: "Es una cadena de 15 números y letras.",
    },
    invitations:
      "Las invitaciones pueden intercambiarse por productos cuando haces un pedido. Diferentes invitaciones pueden intercambiarse por diferentes productos.",
  },
  balance_refund: {
    title: "Devoluciones",
    current_balance: "Mi saldo actual",
    processing_time_tip:
      "La devolución puede tardar hasta 24h en procesarse. Gracias por tu paciencia.",
    tip: "Solicitando una devolución de saldo, recibirás el importe restante en tu chip. Sólo puede devolverse el saldo recargado mediante la aplicación.",
    refundable_balance: "Tu saldo reembolsable en la aplicación es:",
    facility_refundable_balance: "Reembolsa tu saldo restante en {location}:",
    location: {
      hotel: "recepción",
      festival: "el evento",
    },
    requested: "Solicitado",
    status: "Estado",
    updated: "Actualizado",
    pending_refund: "Devolución pendiente",
    status_types: {
      PENDING: "Solicitado",
      NOT_REFUNDABLE: "No reembolsable",
      COMPLETED: "Completado",
      PARTIALLY_COMPLETED: "Completado",
      NOTHING_TO_REFUND: "Nada que reembolsar",
    },
    available_date: "Tu devolución estará disponible a partir del ",
    warnign_balance:
      "Esta aplicación no devuelve recargas hechas en ventanilla",
    warnign_refundable_balance:
      "Solo puede devolver el saldo recargado mediante esta  aplicación o de forma virtual.",
    confirm_action: "Solicitar devolución de saldo",
    success_refund: {
      primary_text: "Devolución solicitada!",
      secondary_text:
        "Tu devolución se está tramitando, recibirás tu dinero en 2-3 días",
    },
    refund_pending: "Tramitando devolución",
  },
  modals: {
    sign_up: {
      title: "¡Te has registrado!",
      content:
        "Revisa tu correo, hemos enviado un email para completar tu registro a <b> {email} </b>",
      legal: "Términos y condiciones",
      legal_notice: "Registrándote, aceptas nuestros ",
      locator:
        "Introduce el código de entrada situado junto al QR/código de barras. Si no aparece, escanéalo para obtenerlo.",
    },
    recover: {
      title: "¡Correo enviado!",
      content:
        "Si el e-mail introducido coincide con el que usaste para registrarte, recibirás las instrucciones para elegir una nueva contraseña.",
    },
    qr: {
      title: "Tu código QR",
      footer: "Este código es tu identificador personal",
    },
  },
  success: {
    edit_profile: "Cambios aplicados correctamente",
  },
  error: {
    server_error:
      "Ha ocurrido un error en el servidor. ¡Trabajamos en solucionarlo!",
    server_unavailable:
      "¡Oops! Parece que el servidor no está disponible. ¡Vuelve más tarde!",
    bad_request: {
      any: {
        required: "Obligatorio",
        empty: "Obligatorio",
      },
      string: {
        base: "Obligatorio",
        email: "E-mail inválido",
        hex: "Código inválido. Debe tener 14 ó 15 dígitos.",
        invalid_tag: "Código inválido. Revisa los dígitos introducidos.",
        min: "No tiene la longitud mínima",
      },
    },
    conflict: {
      EMAIL_IN_USE: "Ya existe una cuenta con este correo electrónico.",
      EMAIL_OR_TOKEN_IN_USE: "Ya existe una cuenta con este correo electrónico.",
      LINK_IN_USE: "Ya se ha creado una cuenta con este ID de chip.",
      NOTHING_TO_REFUND: "Nada que reembolsar.",
      INVALID_TOKEN: "Tu enlace ha caducado. Empieza el proceso de nuevo.",
      NO_TOOLKIT_USER_FOUND: "¡Vaya! No hemos encontrado ese usuario.",
      INVALID_EXTERNAL_TOKEN: "Token de autenticación invalido"
    },
    forbidden: "E-mail o contraseña incorrectos",
    invalid_token: "Token de autenticación invalido",
    agree_terms: "Para continuar debes aceptar los terminos y condiciones",
    user_not_balance: "No tienes saldo que devolver",
    user_not_tag: "No disponible. No tienes un id de tag"
  },
  qr_view: {
    qr_text: "Mostrando tu código QR",
    dismiss_text: "Volver",
  },
  my_account: {
    title: "Mi cuenta",
    user_data: "Datos de usuario",
    change_password: "Cambiar contraseña",
    legal_terms: "Términos legales",
    show_qr_code: "Ver código QR",
    logout: "¿Quieres cerrar sesión?",
    confirm_logout: "Cerrar sesión",
    password_changed: "Contraseña cambiada!",
  },
  recharge: {
    title: "Recarga",
    current_balance: "Saldo actual",
    new_balance: "Nuevo saldo",
    recharge_amount: "Cantidad a recargar",
    card_payment: "Pago con tarjeta",
    recharge_done: "Recarga realizada!",
    no_payment_config: "No se ha configurado método de pago",
  },
  user: {
    title: "Datos usuario",
    cancel: "Cancelar",
    save: "Guardar",
    edit: "Editar",
    ok: "Ok",
    success_response: {
      primary_text: "Datos guardados!",
    },
    save_changes: "Guardar cambios",
  },
  redeem_tag_dialog: {
    text: "Muestra tu Código QR en una estación para canjear tu Chip NFC y disfrutar del evento."
  },
  discount_coupon: {
    expiration: "Caducidad",
    uses: "Usos",
    applicable_products: "Productos aplicables",
    price: "Precio",
  }
};
